<div class="container-fluid" #divLoginPage>
  <div class="row mh-100vh">
    <div class="col-10 col-sm-8 col-md-6 col-lg-6 offset-1 offset-sm-2 offset-md-3 offset-lg-0 align-self-center d-lg-flex align-items-lg-center align-self-lg-stretch bg-white p-5 rounded rounded-lg-0 my-5 my-lg-0" id="login-block">
      <div class="m-auto register-login w-lg-75 w-xl-50">
        <div class="text-center mb-5"><img src="assets/v2/img/EPC-logo.svg" style="width: 185px;"></div>
        <h2 class="text-center" style="font-size: 20px;line-height: 1.5;margin: 20px auto;">Confirmation de votre compte Espace PRO Client<br></h2>
        
        <form action="#" novalidate>
          <div class="alert alert-danger" *ngIf="submitted && isError">
            Une erreur est survenue lors du traitement de votre demande.
          </div>

          <div class="alert alert-success" *ngIf="submitted && !isError && isConfirmed">
            Un lien vous a été envoyé sur votre adresse e-mail {{CryptedEmail}} afin de créer votre mot de passe Espace PRO Client.
          </div>
          <div class="form-group">
            <button class="btn btn-primary btn-block" type="submit" (click)="redirectToLogin()">
              <span class="btn-label">
                <i class="pi pi-unlock"></i>
              </span>Se connecter
            </button>
          </div>
        </form>
      </div>
    </div>
    <div class="col-lg-6 d-flex align-items-end login-bg" id="bg-block" >
      <div></div>
    </div>
  </div>
</div>
